import Vue from "vue";
import Vuex from "vuex";
import httpService from "@/utils/service";
import COVER from "@/utils/COVER";
import COVERAPP from "@/utils/COVERAPP";
import {shareTitle, getLocationPoint, getBaiduLocation} from "@/utils/utils";
import {
    getNotice,
    getRelate,
    queryChat,
    userLog,
    setUser,
    setPosition,
    queryComment,
    discussNews,
    discussNewsOther,
    getHotTopic,
    getHotTopicDesc,
    getHotTopicNews,
    getHotNews,
    getSceneCommon,
    queryMultiProgress,
    queryPoke,
    getSceneMultiProcess,
    queryTourism,
    queryTourSight,
    queryTourDetail,
    queryTourGo,
    queryTourCommon,
    getServiceTime,
    getNextBatch,
    getRobotConfig,
    sendAudiorecorderQuestion,
    discussGuide,
} from "@/api/data";
import audio from './audio'


import HttpRequest from '@/utils/axios'

import { fetchEventSource } from "@microsoft/fetch-event-source";


const share = shareTitle();
Vue.use(Vuex);

let controller = new AbortController()
window.allController = new AbortController();
const eventSource = async (params, url) => {
    let text = ''
    let source = {}
    let indexDataList = []
    let countTime = 0
    const fetchEventSourceFn = fetchEventSource(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(params),
      signal: controller.signal,
      openWhenHidden: true,
      onopen(data) {
        console.log('open')
        console.log('data', data)

        // if(data.status == 401) {
        //   Modal.confirm({
        //     title: '重新登录',
        //     content: '你已被登出，可以取消继续留在该页面，或者重新登录',
        //     cancelText: '取消',
        //     okText: '确定',
        //     onOk: () => {
        //       sessionStorage.clear();
        //       localStorage.clear();
        //       let pathname = location.href
        //       window.location.href = `${domain}/authentication-server/logout?redirect=${pathname}`
        //     }
        //   });
        //   return;
        // }
        // else if (data.status !== 200) {
        //   console.log('eventSource data', data)
        //   message.error(data.statusText || '请求出错！请联系管理员');
        //   return;
        // }
      },
      onmessage:(event) =>{
        // console.log('event 连接数据: ', event)
        let data = event.data
        // let jsonData = JSON.parse(data);
        console.log(data)
        // countTime ++
      },
      onclose() {
        controller.abort();//出错后不要重试
        fetchEventSourceFn.close();
      },
      onerror(error) {
        console.log('连接错误: ', error)
        window.allController.abort(); //出错后不要重试
        fetchEventSourceFn.close();
      }
  
    })
}

export default new Vuex.Store({
    state: {
        isApp: false, //是否在app中
        versionSize: 0, //app版本
        serverTime: 0, // 服务器时间
        userinfo: {}, //用户信息
        shareData: { //分享信息
            title: share.title,
            desc: share.desc,
            // imgUrl: 'https://wapcdn.thecover.cn/wap/1.0.0/img/favicon.png',
            imgUrl:'',
            link: window.location.origin + window.location.pathname
        },
        isImmerse: false, //是否沉浸式
        device: COVERAPP.Attribute.isIOS() ? "ios" : "android",
        maskData: null, //弹框信息
        globalDuration: 0,
        chatLoading: false,
        maskShowStatus: false,
        homeChat: [],
        noticeList: [],
        toastList: [],
        linkSrc: "",
        isClearTimer: true,
        view11Tips: "",  //解决ios11布局问题,
        toastContent: {toastType: 0, list: {name: "", content: ""}},   // toastType:0 内容多提示类  1:选择地点类 选择价格类  2.选择景点类型类 3.导航 4.地点介绍   5.附近美食  6.附近景点  list:{}  name 左上角名称 content:''  or [],
        isToastShow: false,
        readNewsId: "",
        isOpenChat: false, //开启聊新闻模式,
        isInputShow: false,
        isClearInitTimer: false,  //该变量用来设置用户默认信息 如果未得到授权,
        newsContent: {},
        questionTips: "",
        guideTips: "",
        isViewFade: false,
        isTourShow: false,

        selectList: [],
        tourSelectData: [],

        tagsList: [],
        tourSelectType:'',

        diffTime:{},

        robotConfig: {},
        isAudioShow: false,
        isAudioBarShow: true,
        isVoiceInput: false,//是否为语音输入， true 是，false 不是
        AutoplayPlayer: null,//自动播放播放器
        AutoplayIng: false,//更新小封真正播报时候的小封形象状态
        isPermitUseMicrophone: true,
        xmly: null,
        MicrophoneErrorData: "",//访问媒体设置错误的原因
        isEnterFirst: true,//是否为第一次进入页面
        isToSpeakIng: false,//是否为用户正在说话
        isXFAutoplay: false,//是否需要小封自动播报
        ContentType: false,//true表示请求头需要从新设置为	multipart/form-data
        OpenChatID: 0,//0新增新闻模式聊天，1标识功能反馈聊天
        chatData: [], // 聊天数据
        thinkingData: null,
        glSocket: null,
        fetchEventSourceFn: null,
        userId: 100000,
        chatSample: [],
        isVoiceClick: false,
        audioList: [],
    },
    mutations: {
        // 设置是否在app中
        appFlag(state, flag) {
            state.isApp = flag;
        },
        setChatData(state, data) {
            state.chatData.push(data);
        },
        setIsVoiceClick(state, data) {
            state.isVoiceClick = data;
        },
        setAudioList(state, data) {
            state.audioList = data;
        },
        setChatSample(state, data) {
            state.chatSample = data;
        },
        setUserId(state, data) {
            state.userId = data;
        },
        updateChatData(state, data) {
            state.chatData = data;
        },
        setThinkingData(state, data) {
            // state.thinkingData.push(data);
        },
        setVersionSize(state, num) {
            state.versionSize = num;
        },
        setServerTime(state, time) {
            state.serverTime = time;
        },
        setToastData(state, data) {
            state.toastData = data;
        },
        setDiffTime(state, data) {
            state.diffTime = data;
        },
        setPageLoading(state, flag) {
            state.pageLoading = flag;
        },
        setIsImmerse(state, flag) {
            state.isImmerse = flag;
        },

        // 设置用户信息
        getUserinfo(state, data) {
            state.userinfo = data;
        },
        // 设置分享数据
        setshareData(state, data) {
            state.shareData = data;
        },
        // 设置弹窗数据
        setMaskData(state, data) {
            state.maskData = data;
        },
        // 设置获得红包弹窗是否显示
        sethbFlagData(state, data) {
            state.hbFlagData = data;
        },
        // 设置结果页数据
        setResultData(state, data) {
            state.resultData = data;
        },


        /*我的*/
        setViewFade(state, data) {
            if (!data) {
                state.isViewFade = data;
            } else {
                setTimeout(() => {
                    state.isViewFade = data;
                }, 300);
            }

        },
        setHomeData(state, data) {
            state.homeChat = data;
        },
        setNoticeData(state, data) {
            state.noticeList = data;
            state.maskShowStatus = false;
        },
        setToastList(state, data) {
            state.toastList = data;
            state.maskShowStatus = false;
        },
        setGuideTips(state, data) {
            state.guideTips = data;
        },
        setAudioShow(state, data){
            state.isAudioShow = data;
        },
        setAudioBarShow(state, data){
            state.isAudioBarShow = data;
        },
        setVoiceInput(state, data) {
            state.isVoiceInput = data
        },
        setAutoplayPlayer(state, data) {
            state.AutoplayPlayer = data;
        },
        setAutoplayIng(state, data) {
            state.AutoplayIng = data
        },
        setPermitUseMicrophone(state, data) {
            state.isPermitUseMicrophone = data
        },
        setXmly(state, data) {
            state.xmly = data
        },
        setMicrophoneErrorData(state, data) {
            state.MicrophoneErrorData = data
        },
        setEnterFirst(state, data) {
            state.isEnterFirst = data
        },
        setToSpeakIng(state, data) {
            state.isToSpeakIng = data
        },
        setXFAutoplay(state, data) {
            state.isXFAutoplay = data
        },
        setContentType(state, data) {
            state.ContentType = data
        },
        setOpenChatID(state, data) {
            state.OpenChatID = data;
        },
        contactDisData(state, data) {
            state.homeChat = [];
            if (data.length == 1 && data[0].content.right) {
                state.questionTips = data[0].content.tips;
            } else {
                let count = 0;
                if (!data[0].content.right) {
                    if (data[0].content.view == 100) {
                        state.guideTips = data[count].content.tips;
                        if (data[count].content.speechUrl !== "" && data[count].content.speechUrl !== null && data[count].content.speechUrl !== undefined) {
                            // console.log("设置播放的数据源===============",data[count].content.speechUrl)
                            state.AutoplayPlayer.setAttribute('src', data[count].content.speechUrl)
                            // 有语音播报的数据
                            state.AutoplayPlayer.play()
                            state.AutoplayIng = true
                        }
                    }
                    if (data[0].content.view !== 100) {
                        state.guideTips = "";
                    }
                    if (data[data.length - 1].content.view == 101) {
                        state.isTourShow = true;
                        setTimeout(()=>{ state.isClearTimer = true;},0)
                        state.tourSelectType=data[data.length - 1].content.list.value;
                    }
                    if (data[data.length - 1].content.view !== 101) {
                        state.isTourShow = false;
                        // state.isInputShow = false;
                        state.tourSelectType='';
                    }
                    if (data[data.length - 1].content.view == 104) {
                        state.isAudioShow= true
                        state.isInputShow = true
                        state.isAudioBarShow = false
                        setTimeout(()=>{ state.isClearTimer = true;},0)
                    }
                    if (data[data.length - 1].content.view !== 104) {
                        state.isAudioShow = false
                    }
                    //不展示
                    const isInputNotShow= data.findIndex(value=> value.content.view===102)
                    if(isInputNotShow!==-1){state.isInputShow=false;setTimeout(()=>{ state.isClearTimer=true;},100)}
                    //展示
                    const isInputShow= data.findIndex(value=> value.content.view===103)
                    if(isInputShow!==-1){state.isInputShow=true;}
                    state.homeChat = [...state.homeChat, ...data];

                    setTimeout(() => {
                        state.maskShowStatus = false;
                        state.isViewFade = true;
                        httpService.pageScrollTo();
                    }, 0);
                    setTimeout(() => {
                        state.isViewFade = true;
                    }, 300);
                }
            }


        },
        removeSyncLeftData(state, data) {
            // state.homeChat
        },
        //聊新闻使用
        chatDisData(state, data) {
            if (data.isClear) {
                state.homeChat = [];
            }
        },

        setLinkSrc(state, data) {
            state.linkSrc = data;
        },
        setGlobalDuration(state, data) {
            state.globalDuration = data;
        },
        setChatLoading(state, data) {
            state.chatLoading = data;
        },
        setClearTimer(state, data) {
            state.isClearTimer = data;
        },
        setToastContent(state, data) {
            state.toastContent = data;
        },
        setToastShow(state, data) {
          document.getElementById('contentTips').scrollTop=0
          state.isToastShow = data;
        },
        setReadNewsId(state, data) {
            state.readNewsId = data;
        },
        setOpenChat(state, data) {
            state.isOpenChat = data;
        },
        setInputShow(state, data) {
            if (data) {
                // state.isTourShow = false;
                // state.tagsList = [];
                // state.tourSelectData = [];
            }
            state.isInputShow = data;
        },
        setTourShow(state, data) {
            state.isTourShow = data;
        },
        setInitTimer(state, data) {
            state.isClearInitTimer = data;
        },
        setNewsContent(state, data) {
            state.newsContent = data;
        },
        setMaskShowStatus(state, data) {
            state.maskShowStatus = data;
        },
        setSelectList(state, data) {
            state.selectList = data;
        },
        setTourSelectData(state, data) {
            state.tourSelectData = data;
        },
        setTagsList(state, data) {
            if (data.length) {
                const list = state.tagsList;
                if (list.some((item) => {
                    return item.name === data[0].name;
                })) {
                    list.splice(list.findIndex(v => v.name === data[0].name), 1);
                } else {
                    state.tagsList = [...new Set([...state.tagsList, ...data])];
                }
            } else {
                /*当传进来的为[]时重置*/
                state.tagsList = [];
            }
        },
        setSingleTags(state, data) {
            const list = state.tagsList;
            if (data.length) {
                if (list.some((item) => {
                    return item.name === data[0].name;
                })) {
                    list.splice(list.findIndex(v => v.name === data[0].name), 1);
                } else {
                    list.splice(list.findIndex(v => v.name.indexOf("km") > 0), 1);
                    state.tagsList = [...new Set([...state.tagsList, ...data])];
                }
            }
        }
    },
    actions: {
        // 设置是否在app中
        appFlagAsync({commit, state}, flag) {
            commit("appFlag", flag);
        },
        setVersionSizeAsync({commit, state}, num) {
            commit("setVersionSize", num);
        },
        setServerTimeAsync({commit, state}, time) {
            commit("setServerTime", time);
        },

        // 获取用户信息
        getUserInfoAsync({dispatch, commit, state}) {
            COVER.getUser((ret) => {
                // setTimeout(()=>{   commit("setInitTimer",true)},100)
                const userinfo = JSON.parse(JSON.stringify(ret));
                if (COVERAPP.Attribute.isIOS() && userinfo.token) {
                    if (parseInt(state.versionSize) >= 450) {
                        userinfo.nickname = decodeURIComponent(escape(window.atob(userinfo.nickname)));
                    }
                }
                // userLog({position: "store拿到返回", ...ret});
                // console.log('userInfo', userinfo)
                commit("getUserinfo", userinfo);

                // setUser(userinfo).then((res) => {
                //     const {data: {data}} = res;
                //     sessionStorage.setItem("USER_ID", data.id);
                //     // cio.setUser(data.id,  ret.nickname, {userInfo: JSON.stringify(ret)});
                //     const id = sessionStorage.getItem("USER_ID");
                //     if (id || state.userinfo.id) {
                //         commit("setInitTimer", true);
                //         commit("chatDisData", {isClear: []});
                //         dispatch("fetchHome", {payload: {question: ""}}).then(() => {
                //             commit("setClearTimer", false);
                //         });
                //         dispatch("fetchNotice");
                //         // getLocationPoint().then((res) => {
                //         //     setPosition(res);
                //         // });
                //         // getBaiduLocation();
                //     }

                // });
                // userLog(JSON.parse(JSON.stringify(res)))
            });
        },
        // 设置分享数据
        setshareDataAsync({commit, state}, data) {
            commit("setshareData", data);
        },
        // 设置弹窗数据
        setMaskDataAsync({commit, state}, data) {
            commit("setMaskData", data);
        },
        setToastDataAsync({commit, state}, data) {
            commit("setToastData", data);
        },
        setPageLoadingAsync({commit, state}, flag) {
            commit("setPageLoading", flag);
        },
        setIsImmerseAsync({commit, state}, flag) {
            commit("setIsImmerse", flag);
        },
        /*这设置用户信息*/
        setNoInfo({dispatch, state, commit}) {

            const userinfo = {origin: "yk", sessionId: COVER.uuid("uid")};
            commit("getUserinfo", userinfo);
            return new Promise((resolve, reject) => {
                try {
                    setUser(userinfo).then((res) => {
                        const {data: {data}} = res;
                        sessionStorage.setItem("USER_ID", data.id);
                        const id = sessionStorage.getItem("USER_ID");

                        if (id || state.userinfo.id) {
                            commit("chatDisData", {isClear: []});
                            dispatch("fetchHome", {payload: {question: ""}}).then(() => {
                                commit("setClearTimer", false);
                            });
                            dispatch("fetchNotice");
                            // getBaiduLocation();
                            // getLocationPoint().then((res) => {
                            //     setPosition(res);
                            // });
                        }

                    }).catch(err => {
                        reject(err);
                    });
                } catch (error) {
                    reject(error);
                }
            });

        },

        /*我的逻辑*/
        //首页
        fetchHome({state, commit}, {payload}) {
           if(payload.noInput){
               commit("setInputShow",false);
           } else {
               commit("setInputShow", true);
           }
            commit("setOpenChat", false);
            commit("setAutoplayIng", false);
            return new Promise((resolve, reject) => {
                try {
                    queryChat(payload).then((res) => {
                        const {data} = res.data;
                        resolve(data);
                        commit("contactDisData", data);
                        commit("setGlobalDuration", 0);
                        // console.info('payload',payload)
                        if(!(payload.hasClearTimer)){
                            commit("setClearTimer", false);
                        }
                    }).catch(err => {
                        reject(err);
                    });
                } catch (error) {
                    reject(error);
                }
            });
        },
        //请求question接口不拿返回数据
        fetchHomeNoData({state, commit}, {payload}) {
            commit("setInputShow", true);
            commit("setOpenChat", false);
            return new Promise((resolve, reject) => {
                try {
                    queryChat(payload).then((res) => {
                        const {data} = res.data;
                        resolve(data);
                        commit("setGlobalDuration", 0);
                        if(!(payload.hasClearTimer)){
                            commit("setClearTimer", false);
                        }
                    }).catch(err => {
                        reject(err);
                    });
                } catch (error) {
                    reject(error);
                }
            });
        },

        /*戳一戳*/
        queryPoke({state, commit}) {
            commit("setInputShow", true);
            commit("setOpenChat", false);
            commit("setClearTimer", true);
            cio.track(3, "click", "pock");
            return new Promise((resolve, reject) => {
                try {
                    queryPoke().then((res) => {
                        const {data} = res.data;
                        resolve(data);
                        commit("contactDisData", data);
                        commit("setGlobalDuration", 0);
                        // commit("setClearTimer", false);
                    }).catch(err => {
                        reject(err);
                    });
                } catch (error) {
                    reject(error);
                }
            });

        },


        //多流程
        queryMultiProgress({state, commit}, {payload}) {
            commit("setInputShow", false);
            commit("setOpenChat", false);
            return new Promise((resolve, reject) => {
                try {
                    queryMultiProgress(payload).then((res) => {

                        const {data} = res.data;
                        resolve(data);
                        commit("contactDisData", data);
                        commit("setGlobalDuration", 0);
                        commit("setClearTimer", true);
                    }).catch(err => {
                        reject(err);
                    });
                } catch (error) {
                    reject(error);
                }
            });

        },

        //相关问题
        fetchRelate({commit}, {payload}) {
            return new Promise((resolve, reject) => {
                try {
                    getRelate(payload).then((res) => {
                        const {data} = res.data;
                        resolve(data);
                        commit("setToastList", data);
                        // commit("setClearTimer", false);
                    }).catch(err => {
                        reject(err);
                    });
                } catch (error) {
                    reject(error);
                }
            });
        },

        //提示栏
        fetchNotice({commit}) {
            getNotice().then((res) => {
                const {data} = res.data;
                commit("setNoticeData", data);
            });
        },

        //聊新闻
        queryComment({commit}, {payload}) {
            commit("setInputShow", false);
            commit("setChatLoading", true);
            commit("setTourShow",false)
            return new Promise((resolve, reject) => {
                try {
                    queryComment(payload).then((res) => {
                        const {data} = res.data;
                        resolve(data);
                        commit("contactDisData", data);
                        // commit("setClearTimer", true);
                        commit("setChatLoading", false);
                    }).catch(err => {
                        reject(err);
                    });
                } catch (error) {
                    reject(error);
                }
            });
        },

        discussNews({state, commit}, {payload}) {
            commit("setInputShow", false);
            return new Promise((resolve, reject) => {
                try {
                    discussNews(payload).then((res) => {

                        const {data} = res.data;
                        resolve(data);
                        commit("contactDisData", data);
                        commit("setGlobalDuration", 0);
                        commit("setClearTimer", true);
                        commit("setOpenChat", false);

                    }).catch(err => {
                        reject(err);
                    });
                } catch (error) {
                    reject(error);
                }
            });

        },

        discussNewsOther({state, commit}, {payload}) {
            commit("setInputShow", false);
            return new Promise((resolve, reject) => {
                try {
                    discussNewsOther(payload).then((res) => {

                        const {data} = res.data;
                        resolve(data);
                        commit("contactDisData", data);
                        commit("setGlobalDuration", 0);
                        commit("setClearTimer", true);
                    }).catch(err => {
                        reject(err);
                    });
                } catch (error) {
                    reject(error);
                }
            });

        },
        getHotTopic({state, commit}) {
            commit("setInputShow", true);
            commit("contactDisData", [{content: {right: true, tips: ""}}]);
            return new Promise((resolve, reject) => {
                try {
                    getHotTopic().then((res) => {

                        const {data} = res.data;
                        resolve(data);
                        commit("contactDisData", data);
                        // commit("setGlobalDuration", 0);
                        commit("setClearTimer", true);
                        // commit("setOpenChat",false)
                    }).catch(err => {
                        reject(err);
                    });
                } catch (error) {
                    reject(error);
                }
            });

        },
        getHotTopicDesc({state, commit}, {payload}) {
            commit("setInputShow", false);
            return new Promise((resolve, reject) => {
                try {
                    getHotTopicDesc(payload).then((res) => {

                        const {data} = res.data;
                        resolve(data);
                        commit("contactDisData", data);
                        commit("setGlobalDuration", 0);
                        commit("setClearTimer", true);

                        // commit("setOpenChat",false)
                    }).catch(err => {
                        reject(err);
                    });
                } catch (error) {
                    reject(error);
                }
            });

        },
        getHotTopicNews({state, commit}, {payload}) {
            commit("setInputShow", false);
            return new Promise((resolve, reject) => {
                try {
                    getHotTopicNews(payload).then((res) => {

                        const {data} = res.data;
                        resolve(data);
                        commit("contactDisData", data);
                        commit("setGlobalDuration", 0);
                        commit("setClearTimer", true);

                        // commit("setOpenChat",false)
                    }).catch(err => {
                        reject(err);
                    });
                } catch (error) {
                    reject(error);
                }
            });

        },
        getHotNews({state, commit}) {
            commit("setInputShow", false);
            return new Promise((resolve, reject) => {
                try {
                    getHotNews().then((res) => {

                        const {data} = res.data;
                        resolve(data);
                        commit("contactDisData", data);
                        commit("setGlobalDuration", 0);
                        commit("setClearTimer", true);
                        commit("setOpenChat", false);
                    }).catch(err => {
                        reject(err);
                    });
                } catch (error) {
                    reject(error);
                }
            });
        },
        getDiscussGuide({commit}, {payload}) {
            return new Promise((resolve, reject) => {
                try {
                    discussGuide(payload).then((res) => {

                        const {data} = res.data;
                        resolve(data);
                        commit("contactDisData", data);
                        commit("setGlobalDuration", 0);
                        commit("setClearTimer", true);
                        // commit("setOpenChat", false);
                    }).catch(err => {
                        reject(err);
                    });
                } catch (error) {
                    reject(error);
                }
            });
        },
        getSceneCommon({state, commit}) {
            commit("setInputShow", true);
            return new Promise((resolve, reject) => {
                try {
                    getSceneCommon().then((res) => {
                        const {data} = res.data;
                        resolve(data);
                        commit("contactDisData", data);
                        commit("setGlobalDuration", 0);
                        // commit("setClearTimer", false);

                        // commit("setOpenChat",false)
                    }).catch(err => {
                        reject(err);
                    });
                } catch (error) {
                    reject(error);
                }
            });
        },
        getSceneMultiProcess({state, commit}) {
            commit("setInputShow", true);
            return new Promise((resolve, reject) => {
                try {
                    getSceneMultiProcess().then((res) => {

                        const {data} = res.data;
                        resolve(data);
                        commit("contactDisData", data);
                        commit("setGlobalDuration", 0);
                        commit("setClearTimer", false);

                        // commit("setOpenChat",false)
                    }).catch(err => {
                        reject(err);
                    });
                } catch (error) {
                    reject(error);
                }
            });
        },

        /*旅游场景--------------------*/
        queryTourism({state, commit}) {

            return new Promise((resolve, reject) => {
                try {
                    queryTourism().then((res) => {
                        const {data} = res.data;
                        resolve(data);
                        commit("setSelectList", data);
                        // commit("setTourShow", true);
                        commit("setClearTimer", true);
                    }).catch(err => {
                        reject(err);
                    });
                } catch (error) {
                    reject(error);
                }
            });
        },
        getTourData({state, commit}, {payload}) {
            commit("setInputShow", false);
            const tags = [];

            const {tagsList} = state;
            tagsList.map((item) => {
                tags.push(item.name);
            });

            return new Promise((resolve, reject) => {
                try {
                    queryTourSight({ tags}).then((res) => {
                        const {data} = res.data;
                        resolve(data);
                        commit("contactDisData", data);
                        commit("setTourShow", true);
                        commit("setClearTimer", true);
                    }).catch(err => {
                        reject(err);
                    });
                } catch (error) {
                    reject(error);
                }
            });
        },

        /*根据景点ID请求景点详情*/
        getTourInfo({state, commit}, {payload}) {
            return new Promise((resolve, reject) => {
                try {
                    queryTourDetail(payload).then((res) => {
                        const {data} = res.data;
                        resolve(data);
                        commit("contactDisData", data);
                        commit("setTourShow", false);
                        commit("setClearTimer", true);
                        commit("setInputShow", false);
                    }).catch(err => {
                        reject(err);
                    });
                } catch (error) {
                    reject(error);
                }
            });
        },

        /*我想去这里玩*/
        getWantToInfo({state, commit}, {payload}) {
            commit("setInputShow", true);
            return new Promise((resolve, reject) => {
                try {
                    queryTourGo(payload).then((res) => {
                        const {data} = res.data;
                        resolve(data);
                        commit("contactDisData", data);
                        commit("setTourShow", false);
                        commit("setClearTimer", false);
                    }).catch(err => {
                        reject(err);
                    });
                } catch (error) {
                    reject(error);
                }
            });
        },
        /*不感兴趣*/
        getTourCommon({state, commit}) {
            commit("setInputShow", true);
            return new Promise((resolve, reject) => {
                try {
                    queryTourCommon().then((res) => {
                        const {data} = res.data;
                        resolve(data);
                        commit("contactDisData", data);
                        commit("setGlobalDuration", 0);
                        commit("setClearTimer", false);
                        // commit("setOpenChat",false)
                    }).catch(err => {
                        reject(err);
                    });
                } catch (error) {
                    reject(error);
                }
            });
        },

        getServiceTime({commit}) {
            return new Promise((resolve, reject) => {
                try {
                    getServiceTime().then((res) => {
                        const {data} = res.data;
                        commit('setServerTime',data.time)
                        commit('setDiffTime',data)
                        resolve(data);
                        commit("setMaskShowStatus", false);
                    }).catch(err => {
                        reject(err);
                    });
                } catch (error) {
                    reject(error);
                }
            });
        },

        // 获取新闻的下一页
        getNextBatch({state, commit}, {payload}) {
            commit("setOpenChat", false);
            return new Promise((resolve, reject) => {
                try {
                    getNextBatch(payload).then((res) => {
                        const {data} = res.data;
                        resolve(data);
                        commit("contactDisData", data);
                        commit("setGlobalDuration", 0);
                        // if(!(payload.hasClearTimer)){
                        //     commit("setClearTimer", false);
                        // }
                    }).catch(err => {
                        reject(err);
                    });
                } catch (error) {
                    reject(error);
                }
             });
        },

        getRobotConfig({state, commit}) {
            return new Promise((resolve, reject) => {
                try {
                    getRobotConfig().then((res) => {
                        const {data} = res.data;
                        resolve(data);
                        state.robotConfig = data;
                        // commit("contactDisData", data);
                        let shareData = Object.assign(state.shareData, data.shareInfo)
                        commit("setshareData", shareData);
                    }).catch(err => {
                        reject(err);
                    });
                } catch (error) {
                    reject(error);
                }
            });

        },

        // 喜马拉雅回传接口
        asyncGetCallBack({ state, commit }, { payload }) {
            return new Promise((resolve, reject) => {
                // 创建实例
                const url = 'https://api.ximalaya.com/openapi-collector-app/album_browse_records'
                // 获取分类列表
                state.xmly.post(url, { browse_records: JSON.stringify(payload) }).then(res => {
                    if (res.code === 0) {
                        // 成功逻辑（仅成功时 code 为 0）
                    }
                }).catch(error => {
                    console.log(error)
                })
            })
        },

        // 录入语音上传2
        sendAudiorecorder2Async({ state, commit, dispatch }, { payload }) {
            commit("setContentType", true);

            // return new Promise((resolve, reject) => {
            //     try {
            //         sendAudiorecorderQuestion(payload).then((res) => {
            //             // console.log("res.data===???????",res.data)
            //             if(res.data.data[0].lastRecord){
            //                 const { data } = res.data;
            //                 commit("setContentType", false);
            //                 // console.log("res.data===", res.data, "原有的数据---state.homeChat==", state.homeChat)
            //                 let showSpeakData = res.data.data[1]
            //                 let tips = res.data.data[0].content.tips
            //                 if (res.data.data.length === 2 && res.data.data[0].speechRecognition) {
    
            //                     if (state.OpenChatID === 1) {
            //                         // 功能反馈
            //                         let feedbackDataAsyncdata = {
            //                             payload: {
            //                                 content: tips,
            //                                 feedbackDirection: state.feedbackDirection,
            //                                 feedbackType: state.feedbackType,
            //                             },
            //                         }
            //                         dispatch("feedbackDataAsync", feedbackDataAsyncdata).then(() => {
            //                             commit("setOpenChatID", 0)
            //                         });
    
            //                     } else {
            //                         // 闲聊
            //                         let fetchHomeData = { payload: { question: tips, hasClearTimer: false } };
            //                         commit("contactDisData", [showSpeakData]);
            //                         dispatch("fetchHome", fetchHomeData).then(() => {
    
            //                         });
            //                     }
            //                     // 语音识别成功
            //                 } else {
            //                     commit("contactDisData", data);
            //                 }
            //                 commit("setChatLoading", false);
            //             }
            //         }).catch(err => {
            //             reject(err);
            //         });
            //     } catch (error) {
            //         reject(error);
            //     }
            // })
        },

        deepseekSocket({ state, commit, dispatch }, { payload }){
            commit("setChatLoading", true);
            
            // let glSocket = null;
            let thinking = null
            let params = {
                "app_id": "thecover",
                "user_id": "thecover",
                "person": payload?.person,
                "content": payload?.content,
                "history": state.chatData.length > 1 ? state.chatData.reduce((pre, cur) => {
                    if(cur.type == 2) {
                        let item = {
                            user: cur.question,
                            bot: cur.text
                        }
                        pre.push(item)
                    }
                    return pre
                }, []) : [],
                // ...payload.chatIndex,
                // chatIndex

                // "app_id": "thecover",
                // "user_id": "test_user_123",
                // "person": "小封",
                // "content": "你觉得你的父亲怎么样",
                // "others": "",
                // "history": [{"user": "你觉得谁最厉害", "bot": "我觉得你最厉害"}, {"user": "为什么", "bot": "因为你是我的主人"}, {"user": "你的父亲是谁", "bot": "我的父亲是封面新闻"}]

            }

            const {chatData} = state;

            // 初始化语音播放列表
            state.audioList = []

            if(!thinking && !payload.chatIndex) {
                // commit("setChatData", {type: 2, question: params.content});
                state.chatData = [...state.chatData, {type: 2, question: params.content}]
            }

            if(payload.chatIndex && state.chatData[payload.chatIndex]) {
                // commit("setChatData", {type: 2, question: params.content});
                state.chatData[payload.chatIndex].isThinking = true;
                state.chatData[payload.chatIndex].reasoning_text = '';
                state.chatData[payload.chatIndex].text = '';
                state.chatData[payload.chatIndex].isOver = false;
            }

            if(payload.answer) {
                let newChatData = [...chatData]
                let item = {
                    type: 2, 
                    question: params.content, 
                    text: payload.answer, 
                    isSample: true
                }
                newChatData[newChatData.length] = item;
                state.chatData = [...newChatData];

                if(payload.audio) {
                    // state.AutoplayPlayer.setAttribute('src', payload.audio)
                    // // 有语音播报的数据
                    // state.AutoplayPlayer.play()
                    // state.AutoplayIng = true

                    let list = [payload.audio]
                    // 异步
                    // commit("setAudioList", list);
                    state.audioList = list
                }

                state.AutoplayPlayer.playbackRate = 1.1

                // commit("setChatLoading", false);
                return true
            } else {
                state.AutoplayPlayer.playbackRate = 1
            }


            let protocol = location.protocol.includes('https') ? 'https' : 'https'
            // let prev = location.protocol.includes('https') ? 'review-cloud.data-test.thecover.cn' : '170.240.110.153:9999'
            // let prev = location.protocol.includes('https') ? 'yun.thecover.cn' : '170.240.110.153:9999'
            let prev = location.host.includes('yun.thecover.cn') ? 'yun.thecover.cn' : 'yun.thecover.cn'
            let url = `${protocol}://${prev}/govllm/bailian`

            // eventSource(params, `http://${prev}/famouschat-roleplay/deepseek`)

            let text = ''
            let thinkingText = ''
            let source = {}
            let indexDataList = []
            let countTime = 0
            if(state.fetchEventSourceFn) {
                controller.abort();//出错后不要重试
                window.allController.abort(); //出错后不要重试
                // state?.fetchEventSourceFn.close();
            }

            controller.abort();//出错后不要重试
            window.allController.abort(); //出错后不要重试
            state.fetchEventSourceFn = fetchEventSource(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(params),
                signal: controller.signal,
                openWhenHidden: true,
                onopen(data) {
                    if (data.status !== 200) {
                        let newChatData = [...chatData]
                        let item = {type: 3, text: data.text || data.message || '不好意思，目前我还没有掌握足够的知识来解答你的这个问题。', question: params.content}
                        newChatData[newChatData.length] = item;
                        state.chatData = [...newChatData];
                        return;
                    }
                },
                onmessage:(event) =>{
                    let data = {}
                    try {
                        if(!event.data) {
                            console.log("event: ", event)
                            return
                        }

                        // if(!state.chatLoading) {
                        //     console.log("停止回复")
                        //     return 
                        // }

                        data= JSON.parse(event.data)

                        if(data.code !== 200) {
                            console.log('连接错误状态码: ', data.code)
                            let newChatData = [...chatData]
                            let item = {type: 3, text: data.text || data.message || '不好意思，目前我还没有掌握足够的知识来解答你的这个问题。', question: params.content}
                            newChatData[newChatData.length] = item;
                            state.chatData = [...newChatData];
                            return
                        }
                        if(data.reasoning_text) {
                            thinkingText += data.reasoning_text
                            thinking = {
                                type: 2,
                                reasoning_text: thinkingText,
                                text: '',
                                isThinking: true,
                                question: payload.content,
                            }
                        }
                        if(data.text) {
                            text += data.text
                            thinking = {
                                type: 2, 
                                reasoning_text: thinkingText,
                                text: text,
                                isThinking: false,
                                question: payload.content,
                            }
                        }

                        if(data.audio) {
                            let list = state.audioList
                            list.push(data.audio)
                            // 异步
                            // commit("setAudioList", list);
                            state.audioList = list

                            // state.AutoplayPlayer.setAttribute('src', data.audio)
                            // // 有语音播报的数据
                            // state.AutoplayPlayer.play()
                            // state.AutoplayIng = true
                        }

                        // 回答结束
                        if(data.finish_reason == 1) {
                            thinking = {
                                type: 2,
                                reasoning_text: thinkingText,
                                text: text,
                                isThinking: false,
                                isOver: true,
                                question: payload.content,
                            }
    
                            commit("setChatLoading", false);
                        }
    
                        if(!thinking) {
                            console.log('setChatData: ', params.content)
                            // commit("setChatData", {type: 2, question: params.content});
                            // let newChatData = [...chatData]
                            // state.chatData = [...newChatData];
                        } else {
                            if(!payload.chatIndex) {
                                let newChatData = [...chatData]
                                let item = newChatData[newChatData.length]
                                item = {
                                    ...item,
                                    ...thinking,
                                    question: payload.content,
                                    thinking: thinking,
                                    // list: [thinking]
                                }
                                // item = thinking
                                if(thinking.isOver) {
                                    if(item.list) {
                                        // item.list.push(thinking)
                                    }  else {
                                        item.list = [thinking]
                                    }
                                    // commit("setChatLoading", false);
                                }
                                newChatData[newChatData.length] = item;
                                state.chatData = [...newChatData];
                                // if(state.chatLoading) {
                                //     state.chatData = [...newChatData];
                                // }
                            } else {
                                let newChatData = [...chatData]
                                let index = payload.chatIndex
                                let item = newChatData[index]
                                item = {
                                    ...item,
                                    ...thinking,
                                    question: payload.content,
                                    thinking: thinking,
                                }
    
                                if(thinking.isOver) {
                                    console.log("item.list: ", item.list)
                                    console.log('payload.chatListIndex: ', payload.chatListIndex)
                                    if(item.list && item.list.length < payload.chatListIndex + 1) {
                                        item.list.push(thinking)
                                    }  else {
                                        // item.list = [item.thinking, thinking]
                                    }
                                }
                                
                                // item = thinking
                                // if(thinking.isOver) {
                                //     if(item.list) {
                                //         item.list.push(thinking)
                                //     }  else {
                                //         item.list = [thinking]
                                //     }
                                // }
                                // {
                                //     type: 2,
                                //     thinkingList: item.thinkingList ? [thinking] : [thinking]
                                // }
                                newChatData[index] = item
                                state.chatData = [...newChatData];
                                // if(state.chatLoading) {
                                //     state.chatData = [...newChatData];
                                // }
                                // console.log('state.chatData: ', state.chatData)
                            }
                        }
                    } catch(e) {
                        console.log('报错event: ', event)
                    }
                },
                onclose() {
                    // console.log("连接中断")
                    commit("setChatLoading", false);
                    controller.abort();//出错后不要重试
                    // state?.fetchEventSourceFn.close();
                },
                onerror(error) {
                    console.log('连接错误: ', error)
                    commit("setChatLoading", false);
                    // state.AutoplayIng = false
                    let newChatData = [...chatData]
                    let item = {type: 3, text: '网络异常请重试。', question: params.content}
                    newChatData[newChatData.length] = item;
                    state.chatData = [...newChatData];

                    window.allController.abort(); //出错后不要重试
                    state?.fetchEventSourceFn.close();
                }
            
            })
        },

        stopDeepseekSocket({ state, commit, dispatch }, { payload }) {
            console.log("stopDeepseekSocket")
            const {chatData} = state;
            let newChatData = [...chatData]
            newChatData = newChatData.map(item => {
                item.isOver = true;
                return item
            })
            state.chatData = [...newChatData];
            commit("setChatLoading", false);

            controller.abort();
            window.allController.abort(); //出错后不要重试
            state?.fetchEventSourceFn.close();
        },

    },
    modules: {}
});
